/* QC Trade header: predictive search, category mega menus, mobile drawer,
   scroll condense / hide-on-scroll. Loaded (deferred) by the header and the
   category bar; guarded so it initialises once. */
(function () {
  'use strict';
  if (window.__qcHeaderInit) return;
  window.__qcHeaderInit = true;

  var root = document.documentElement;
  var desktopMq = window.matchMedia('(min-width: 990px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function highlight(text, term) {
    var safe = escapeHtml(text);
    if (!term) return safe;
    var t = term.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!t) return safe;
    try {
      return safe.replace(new RegExp('(' + t + ')', 'ig'), '<mark>$1</mark>');
    } catch (e) {
      return safe;
    }
  }

  /* ------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------ */
  if (!customElements.get('qc-search')) {
    class QcSearch extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.input = this.querySelector('[data-qc-search-input]');
        this.results = this.querySelector('[data-qc-search-results]');
        this.status = this.querySelector('[data-qc-search-status]');
        this.i18n = {};
        try {
          var i18nEl = this.querySelector('[data-qc-search-i18n]');
          if (i18nEl) this.i18n = JSON.parse(i18nEl.textContent) || {};
        } catch (e) { this.i18n = {}; }
        this.form = this.querySelector('form');
        if (!this.input || !this.results) return;
        this.suggestUrl = this.dataset.suggestUrl || '/search/suggest.json';
        this.searchUrl = this.dataset.searchUrl || '/search';
        this.currency = this.dataset.currency || 'AUD';
        this.timer = null;
        this.controller = null;
        this.activeIndex = -1;
        this.cache = {};
        try {
          this.money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.currency });
        } catch (e) {
          this.money = null;
        }

        this.input.addEventListener('input', () => this.onInput());
        this.input.addEventListener('focus', () => {
          if (this.input.value.trim().length >= 2 && this.results.innerHTML) this.open();
        });
        this.input.addEventListener('keydown', (e) => this.onKeydown(e));
        this.results.addEventListener('mousedown', (e) => e.preventDefault());
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.close();
        });
      }

      onInput() {
        var term = this.input.value.trim();
        clearTimeout(this.timer);
        if (term.length < 2) {
          this.close();
          this.results.innerHTML = '';
          return;
        }
        this.timer = setTimeout(() => this.fetch(term), 200);
      }

      fetch(term) {
        if (this.cache[term]) {
          this.render(term, this.cache[term]);
          return;
        }
        if (this.controller) this.controller.abort();
        this.controller = 'AbortController' in window ? new AbortController() : null;
        var url =
          this.suggestUrl +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=6' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';
        this.setAttribute('aria-busy', 'true');
        fetch(url, { signal: this.controller ? this.controller.signal : undefined, headers: { Accept: 'application/json' } })
          .then((r) => {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then((data) => {
            var res = (data && data.resources && data.resources.results) || {};
            this.cache[term] = res;
            if (this.input.value.trim() === term) this.render(term, res);
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            // Predictive search unavailable: leave plain form submit (/search) working.
            this.close();
          })
          .finally(() => this.removeAttribute('aria-busy'));
      }

      price(p) {
        var raw = p.price != null ? p.price : p.price_min;
        if (raw == null) return '';
        var num = parseFloat(String(raw));
        if (isNaN(num)) return '';
        return this.money ? this.money.format(num) : '$' + num.toFixed(2);
      }

      t(key, fallback, term) {
        var str = (this.i18n && this.i18n[key]) || fallback;
        if (term == null) return escapeHtml(str);
        var parts = String(str).split('[term]');
        return parts.map(escapeHtml).join('&ldquo;' + escapeHtml(term) + '&rdquo;');
      }

      render(term, res) {
        var id = this.input.id;
        var products = res.products || [];
        var collections = res.collections || [];
        var queries = (res.queries || []).filter(function (q) {
          return q.text && q.text.toLowerCase() !== term.toLowerCase();
        }).slice(0, 4);
        var html = '';
        var n = 0;
        var self = this;

        if (queries.length) {
          html += '<div class="qc-search__group" role="presentation"><p class="qc-search__group-title" role="presentation">' + this.t('suggestions', 'Suggestions') + '</p>';
          queries.forEach(function (q) {
            html += '<a class="qc-search__option" role="option" aria-selected="false" id="' + id + '-opt-' + n++ + '" href="' + escapeHtml(q.url) + '">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg>' +
              '<span>' + highlight(q.text, term) + '</span></a>';
          });
          html += '</div>';
        }
        if (products.length) {
          html += '<div class="qc-search__group" role="presentation"><p class="qc-search__group-title" role="presentation">' + this.t('products', 'Products') + '</p>';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            var imgUrl = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
            var meta = [p.vendor, p.product_type].filter(Boolean).map(escapeHtml).join(' &middot; ');
            html += '<a class="qc-search__option" role="option" aria-selected="false" id="' + id + '-opt-' + n++ + '" href="' + escapeHtml(p.url) + '">' +
              '<span class="qc-search__thumb">' + (imgUrl ? '<img src="' + escapeHtml(imgUrl) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>' +
              '<span class="qc-search__meta"><strong>' + highlight(p.title, term) + '</strong>' +
              '<small>' + (meta ? meta + ' &middot; ' : '') + '<span class="qc-search__price">' + escapeHtml(self.price(p)) + '</span></small></span></a>';
          });
          html += '</div>';
        }
        if (collections.length) {
          html += '<div class="qc-search__group" role="presentation"><p class="qc-search__group-title" role="presentation">' + this.t('collections', 'Collections') + '</p>';
          collections.forEach(function (c) {
            html += '<a class="qc-search__option" role="option" aria-selected="false" id="' + id + '-opt-' + n++ + '" href="' + escapeHtml(c.url) + '">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3.5" y="3.5" width="7" height="7" rx="2"/><rect x="13.5" y="3.5" width="7" height="7" rx="2"/><rect x="3.5" y="13.5" width="7" height="7" rx="2"/><rect x="13.5" y="13.5" width="7" height="7" rx="2"/></svg>' +
              '<span>' + highlight(c.title, term) + '</span></a>';
          });
          html += '</div>';
        }
        if (!products.length && !collections.length && !queries.length) {
          html += '<p class="qc-search__empty" role="presentation">' + this.t('empty', 'No quick matches for [term]. Press Enter to search the full catalogue.', term) + '</p>';
        }
        var allUrl = this.searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        html += '<a class="qc-search__option qc-search__option--all" role="option" aria-selected="false" id="' + id + '-opt-' + n++ + '" href="' + escapeHtml(allUrl) + '">' +
          '<span>' + this.t('viewAll', 'View all results for [term]', term) + '</span><span aria-hidden="true">&rarr;</span></a>';

        this.results.innerHTML = html;
        this.options = Array.prototype.slice.call(this.results.querySelectorAll('[role="option"]'));
        this.activeIndex = -1;
        this.input.removeAttribute('aria-activedescendant');
        if (this.status) {
          this.status.textContent = products.length + ' products, ' + collections.length + ' collections found';
        }
        this.open();
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (this.results.hidden) return;
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.activeIndex = -1;
      }

      setActive(i) {
        if (!this.options || !this.options.length) return;
        var len = this.options.length;
        this.activeIndex = (i + len) % len;
        this.options.forEach((o, idx) => o.setAttribute('aria-selected', idx === this.activeIndex ? 'true' : 'false'));
        var el = this.options[this.activeIndex];
        this.input.setAttribute('aria-activedescendant', el.id);
        el.scrollIntoView({ block: 'nearest' });
      }

      onKeydown(e) {
        var openNow = !this.results.hidden;
        if (e.key === 'ArrowDown') {
          if (!openNow && this.results.innerHTML) this.open();
          e.preventDefault();
          this.setActive(this.activeIndex + 1);
        } else if (e.key === 'ArrowUp') {
          if (!openNow) return;
          e.preventDefault();
          this.setActive(this.activeIndex - 1);
        } else if (e.key === 'Enter') {
          if (openNow && this.activeIndex > -1 && this.options[this.activeIndex]) {
            e.preventDefault();
            window.location.href = this.options[this.activeIndex].href;
          }
        } else if (e.key === 'Escape') {
          if (openNow) {
            e.preventDefault();
            this.close();
          } else if (this.input.value) {
            this.input.value = '';
          }
        }
      }
    }
    customElements.define('qc-search', QcSearch);
  }

  /* ------------------------------------------------------------------
     Category bar mega menus
     ------------------------------------------------------------------ */
  function initCatbar(bar) {
    if (bar.dataset.qcReady) return;
    bar.dataset.qcReady = '1';
    bar.classList.add('qc-js');
    var items = Array.prototype.slice.call(bar.querySelectorAll('[data-qc-item]'));
    var openItem = null;
    var openTimer = null;
    var closeTimer = null;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    function toggleOf(item) {
      return item.querySelector('[data-qc-toggle]');
    }
    function panelOf(item) {
      return item.querySelector('[data-qc-panel]');
    }
    function open(item) {
      if (!panelOf(item)) return;
      if (openItem && openItem !== item) close(openItem, true);
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      var t = toggleOf(item);
      if (t) t.setAttribute('aria-expanded', 'true');
      bar.classList.add('has-open');
      openItem = item;
    }
    function close(item, immediate) {
      if (!item) return;
      item.classList.remove('is-open');
      var t = toggleOf(item);
      if (t) t.setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
      if (!openItem) bar.classList.remove('has-open');
    }
    function closeAll() {
      items.forEach(function (i) { close(i, true); });
    }
    bar._qcCloseAll = closeAll;

    items.forEach(function (item) {
      var toggle = toggleOf(item);
      var panel = panelOf(item);
      if (!panel) return;

      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !canHover.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 120);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(item); }, 180);
      });

      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            close(item);
          } else {
            open(item);
          }
        });
        toggle.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            open(item);
            var first = panel.querySelector('a, button');
            if (first) first.focus();
          }
        });
      }

      panel.addEventListener('keydown', function (e) {
        var links = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])'));
        var idx = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          if (links.length) links[(idx + 1) % links.length].focus();
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          if (idx <= 0) {
            if (toggle) toggle.focus();
          } else {
            links[idx - 1].focus();
          }
        } else if (e.key === 'Home') {
          e.preventDefault();
          if (links.length) links[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          if (links.length) links[links.length - 1].focus();
        }
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    // Left/right between top-level triggers
    var tops = Array.prototype.slice.call(bar.querySelectorAll('.qc-catbar__all, .qc-catbar__link'));
    tops.forEach(function (el, i) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          tops[(i + 1) % tops.length].focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          tops[(i - 1 + tops.length) % tops.length].focus();
        }
      });
    });

    bar.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var t = toggleOf(openItem);
        close(openItem);
        if (t) t.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (openItem && !bar.contains(e.target)) closeAll();
    });
  }

  /* ------------------------------------------------------------------
     Mobile drawer
     ------------------------------------------------------------------ */
  function initDrawer() {
    var drawer = document.getElementById('qc-drawer');
    if (!drawer || drawer.dataset.qcReady) return;
    drawer.dataset.qcReady = '1';
    var lastToggle = null;
    var closeTimer = null;

    function setExpanded(v) {
      document.querySelectorAll('[data-qc-drawer-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', v ? 'true' : 'false');
      });
    }
    function openDrawer(trigger) {
      lastToggle = trigger || null;
      clearTimeout(closeTimer);
      if (!drawer.open) {
        if (typeof drawer.showModal === 'function') drawer.showModal();
        else drawer.setAttribute('open', '');
      }
      root.classList.add('qc-lock');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      });
      setExpanded(true);
    }
    function closeDrawer() {
      if (!drawer.open) return;
      drawer.classList.remove('is-open');
      setExpanded(false);
      root.classList.remove('qc-lock');
      var done = function () {
        if (drawer.classList.contains('is-open')) return;
        if (typeof drawer.close === 'function') drawer.close();
        else drawer.removeAttribute('open');
        if (lastToggle) lastToggle.focus();
      };
      closeTimer = setTimeout(done, reduceMotion.matches ? 0 : 320);
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-qc-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawer(opener);
        return;
      }
      if (e.target.closest && e.target.closest('[data-qc-drawer-close]')) {
        closeDrawer();
        return;
      }
      // click on backdrop (outside panel)
      if (e.target === drawer) closeDrawer();
    });
    drawer.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeDrawer();
    });
    desktopMq.addEventListener('change', function (e) {
      if (e.matches) closeDrawer();
    });
  }

  /* ------------------------------------------------------------------
     Scroll: condense header + hide/show category bar
     ------------------------------------------------------------------ */
  function initScroll() {
    var section = document.querySelector('.qc-catbar-section');
    var bar = document.querySelector('[data-qc-catbar]');
    var hideMode = bar && bar.dataset.stickyMode === 'hide';
    var last = 0;
    var ticking = false;
    var acc = 0;

    function readTop(target) {
      if (target && target !== document && target.nodeType === 1 && target.scrollHeight > target.clientHeight) {
        return target.scrollTop;
      }
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    // Publish how much of the header stack is currently covering the top of the viewport
    // (sticky header row + category bar when it is shown) so sticky page content such as
    // the PDP details column can sit underneath it instead of behind it.
    var group = document.getElementById('header-group');
    var lastOffset = -1;
    function publishOffset() {
      if (!group) return;
      var bottom = 0;
      for (var i = 0; i < group.children.length; i++) {
        var r = group.children[i].getBoundingClientRect();
        if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
      }
      bottom = Math.max(0, Math.round(bottom));
      if (bottom !== lastOffset) {
        lastOffset = bottom;
        root.style.setProperty('--qc-sticky-offset', bottom + 'px');
      }
    }
    if (section) section.addEventListener('transitionend', publishOffset);
    window.addEventListener('resize', publishOffset, { passive: true });

    function update(target) {
      var y = readTop(target);
      root.classList.toggle('qc-scrolled', y > 8);
      if (section && hideMode && desktopMq.matches) {
        var delta = y - last;
        var busy = bar.classList.contains('has-open') || bar.contains(document.activeElement);
        if (y < 160 || busy) {
          section.classList.remove('qc-catbar-hidden');
          acc = 0;
        } else {
          acc = (acc > 0) === (delta > 0) ? acc + delta : delta;
          if (acc > 24) section.classList.add('qc-catbar-hidden');
          else if (acc < -12) section.classList.remove('qc-catbar-hidden');
        }
      } else if (section) {
        section.classList.remove('qc-catbar-hidden');
      }
      last = y;
      publishOffset();
    }
    function onScroll(e) {
      var target = e && e.target;
      // Only react to page-level scrolling (window or the page wrapper)
      if (target && target !== document && target.nodeType === 1 && !target.classList.contains('page-wrapper')) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update(target);
      });
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    update(document.querySelector('.page-wrapper'));
  }

  function init() {
    document.querySelectorAll('[data-qc-catbar]').forEach(initCatbar);
    initDrawer();
    initScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-qc-catbar]').forEach(initCatbar);
    var d = document.getElementById('qc-drawer');
    if (d && !d.dataset.qcReady) initDrawer();
  });
})();
